import { ClFarmStore } from "@/domains/cl-farm/cl-farm-store"

export const AlmProviderImageLink = ({ clFarm }: { clFarm: ClFarmStore }) => {
  if (clFarm.alm === "Fertilizer") {
    const size = 16
    return (
      <AlmLink clFarm={clFarm} className="flex items-center gap-1">
        <img src="/assets/alm/fertilizer.svg" height={size} width={size} />{" "}
        <span className="text-t100 text-xs">Fertilizer</span>
      </AlmLink>
    )
  }
  if (clFarm.alm === "Gamma") {
    const multiplier = 0.84
    return (
      <AlmLink clFarm={clFarm}>
        <img src="/assets/alm/gamma-100.png" height={27 * multiplier} width={100 * multiplier} />
      </AlmLink>
    )
  }
  if (clFarm.alm === "Ichi") {
    return (
      <AlmLink clFarm={clFarm}>
        <img src="/assets/alm/ichi-100.png" height={34 * 0.54} width={100 * 0.54} />
      </AlmLink>
    )
  }
  if (clFarm.alm === "Steer") {
    const multiplier = 0.24
    return (
      <AlmLink clFarm={clFarm}>
        <img src="/assets/alm/steer.svg" height={56 * multiplier} width={400 * multiplier} />
      </AlmLink>
    )
  }

  return null
}

const AlmLink = ({
  clFarm,
  children,
  className,
}: {
  clFarm: ClFarmStore
  children: React.ReactNode
  className?: string
}) => {
  return (
    <a
      href={clFarm.providerApp}
      target="_blank"
      title={`Visit ${clFarm.alm}, a Scale ALM partner.`}
      className={className}
    >
      {children}
    </a>
  )
}
